import {Stack} from '@mui/material';
import {Drawer} from 'presentation/components/Drawer';
import styled from 'styled-components';

const DrawerContentContainer = styled(Drawer.Content)`
	margin-top: 16px;

	${({theme}) => theme.breakpoints.down('sm')} {
		margin-top: 0;
		padding: 0;
		background-color: ${({theme}) => theme.colors.gray['20Percent']};
	}
`;

const SearchBarContainer = styled(Stack)`
	background-color: unset;
	box-shadow: unset;
	padding: 12px 0 8px;

	gap: 12px;

	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 12px 16px;
		background-color: ${({theme}) => theme.colors.gray['10Percent']};
		box-shadow: '0px 4px 22px 0px #33333314';
	}
`;

export {DrawerContentContainer, SearchBarContainer};
